import { scrollAnimation } from './function/scroll-animation.js';
import '/assets/js/common.js';
import '/assets/css/common.scss';
import '/assets/css/facility.scss';